import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TransactionWrapper } from '@core/models';
import { catchError, map, of } from 'rxjs';
import { ConnectionService } from '../services/connection.service';

export const summaryResolver: ResolveFn<TransactionWrapper | null> = route => {
  const configurationService = inject(ConnectionService);
  const transactionId = route.params['id'];
  configurationService.token = route.queryParams['token'];
  if (!transactionId || !Number.isFinite(Number(transactionId))) {
    return of(null);
  }

  return configurationService.getTransactionById(transactionId).pipe(
    map(transaction => {
      return transaction.data ?? null;
    }),
    catchError(() => {
      return of(null);
    })
  );
};
